import React, { useState, useEffect } from 'react';
import { topics } from '../../styles/components';
import { getFAQs } from '../../utils/api';

interface FAQEntry {
  short_description: string;
  question: string;
}

interface FAQSectionProps {
  onQuestionSelect: (question: string) => void;
}

const FAQSection: React.FC<FAQSectionProps> = ({ onQuestionSelect }) => {
  const [faqEntries, setFaqEntries] = useState<FAQEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFAQs = async () => {
      try {
        setLoading(true);
        const data = await getFAQs();
        setFaqEntries(data.entries);
        setError(null);
      } catch (err) {
        console.error('Error loading FAQs:', err);
        setError('Unable to load frequently asked questions.');
      } finally {
        setLoading(false);
      }
    };

    loadFAQs();
  }, []);

  const handleFAQClick = (question: string) => {
    onQuestionSelect(question);
  };

  if (loading) {
    return <div className="text-center py-4">Loading frequently asked questions...</div>;
  }

  if (error) {
    return <div className="text-center py-4 text-error">{error}</div>;
  }

  if (faqEntries.length === 0) {
    return <div className="text-center py-4">No frequently asked questions available yet.</div>;
  }

  return (
    <div>
      <h2 className={topics.sectionHeader}>Frequently Asked Questions</h2>
      <div className="space-y-3 mt-4">
        {faqEntries.map((faq, index) => (
          <div 
            key={index}
            className="bg-component p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer"
            onClick={() => handleFAQClick(faq.question)}
          >
            <p className="font-medium text-primary">{faq.short_description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
